goog.provide("shadow.js.shim.module$src$svg$controls$target_svg$default");
shadow.js.shim.module$src$svg$controls$target_svg$default = shadow.js.shim.module$src$svg$controls$target_svg.default;
